import React, { useEffect, useRef, useState } from "react";

import Icon from "../../../../components/Icon";

// Menu de ações por linha: só o ícone, porque clicar na linha já abre o
// lançamento e o menu é atalho para o resto. Usa o mesmo menu do
// ButtonDropdown. `actions`: [{ text, svg, action, disabled }].
export const RowActionsMenu = ({ actions, dropUp }) => {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = event => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const run = action => {
        setOpen(false);
        action.action();
    };

    return (
        <div className="finance-row-actions-menu" ref={containerRef}>
            <button
                type="button"
                className={`row-actions-toggle${open ? ' open' : ''}`}
                onClick={() => setOpen(!open)}
                aria-label="Ações"
                title="Ações"
            >
                <Icon name="more-vertical" size={18} />
            </button>
            {open &&
                <div className={`dropdown-menu ${dropUp ? 'up' : ''}`}>
                    {actions.map((action, index) => (
                        <button key={index} type="button" className="dropdown-item" onClick={() => run(action)} disabled={action.disabled}>
                            {action.svg && <Icon name={action.svg} size={16} />}
                            {action.text}
                        </button>
                    ))}
                </div>
            }
        </div>
    );
};

export default RowActionsMenu;
